import { t } from 'i18next'
import { IMenuConfig, renderMenuIcon } from './menuConfig'
import { PERMIT_MODULES } from '@/services/permission'

// 个人版
export const personalMenuConfig = (): IMenuConfig[] => {
  return [
    {
      path: '/',
      // name: t('menu.taskPlan.title'),
      name: t('menu.rebuild.title'), // 云重建
      icon: renderMenuIcon('rebuild2'),
      permissions: [
        PERMIT_MODULES.FARM_PLAN.CHECK,
        PERMIT_MODULES.MEDIA_PHOTO.CHECK,
        PERMIT_MODULES.FRUIT_PLAN.CHECK,
        PERMIT_MODULES.MAPPING_AUTH.CHECK
      ],
      children: [
        {
          path: '/media',
          name: t('menu.manage.subMenu.media'),
          permissions: [PERMIT_MODULES.MEDIA_PHOTO.CHECK, PERMIT_MODULES.MEDIA_REBUILD.CHECK]
        },
        {
          path: '/task/farm',
          name: t('menu.taskPlan.subMenu.farm'),
          permissions: [PERMIT_MODULES.FARM_PLAN.CHECK]
        },
        {
          path: '/task/fruit',
          name: t('menu.taskPlan.subMenu.fruit'),
          permissions: [PERMIT_MODULES.FRUIT_PLAN.CHECK]
        },
        {
          path: '/v2/mapping-auth',
          name: t('menu.mappingAuth.title'),
          icon: renderMenuIcon('map-auth'),
          permissions: [PERMIT_MODULES.MAPPING_AUTH.CHECK]
        }
      ]
    },
    {
      path: '/records',
      name: t('pages.record.flight.records'),
      icon: renderMenuIcon('records'),
      permissions: [PERMIT_MODULES.RECORDS.CHECK]
    },
    {
      path: '/mission',
      name: t('pages.mission.home.list.title'),
      icon: renderMenuIcon('plots'),
      permissions: [PERMIT_MODULES.PLOT.CHECK]
    },
    {
      path: '/',
      name: t('menu.analysis.title'),
      icon: renderMenuIcon('agro-analyze'),
      permissions: [
        PERMIT_MODULES.MULTI_SPECTRAL.CHECK,
        PERMIT_MODULES.PATROL_FARM.CHECK,
        PERMIT_MODULES.CROP_ESTIMATION.CHECK,
        PERMIT_MODULES.SEEDLING.CHECK,
        PERMIT_MODULES.TP_FERTILIZER.CHECK,
        PERMIT_MODULES.PLOT.CHECK
      ],
      children: [
        {
          path: '/task/multi-spectral',
          name: t('menu.taskPlan.subMenu.multiSpetral'),
          permissions: [PERMIT_MODULES.MULTI_SPECTRAL.CHECK]
        },
        {
          path: '/v2/patrol-farm',
          name: t('menu.taskPlan.subMenu.partrolFarm'),
          permissions: [PERMIT_MODULES.PATROL_FARM.CHECK]
        },
        {
          path: '/analysis/crop-estimation',
          name: t('menu.analysis.subMenu.cropEstimation'),
          permissions: [PERMIT_MODULES.CROP_ESTIMATION.CHECK]
        },
        {
          path: '/v2/seedling',
          name: '出苗分析',
          permissions: [PERMIT_MODULES.SEEDLING.CHECK]
        },
        {
          path: 'v2/fertilizer',
          name: t('menu.manage.subMenu.thirdPartyFertilizer'),
          permissions: [PERMIT_MODULES.TP_FERTILIZER.CHECK]
        },
        {
          path: '/v2/plots',
          name: t('menu.plots.title'),
          permissions: [PERMIT_MODULES.PLOT.CHECK]
        }
      ]
    },
    {
      path: '/devices',
      name: t('pages.devices.manage'),
      icon: renderMenuIcon('devices'),
      permissions: [PERMIT_MODULES.DEVICE.MANAGE]
    }
  ]
}
